module.exports = __webpack_public_path__ + "img/icon-car.4336b2a6.svg";